import { GlobalState, UI } from '@leverege/ui-redux';
import { Config } from '@leverege/plugin';
// eslint-disable-next-line import/no-cycle
import Molten from "../../Molten.js";
import MoltenUtil from "../../MoltenUtil.js";
import { promiseRetry } from "../../Util.js";
const FIVE_MINUTES = 1000 * 60 * 5;

/**
 * Creates an initializer and provider creator for Api
 */
export default {
  id: 'molten.ReleaseMonitor',
  sort: -80,
  onLoggedIn: molten => {
    // Create the opts for api. 
    const apiOpts = {
      ...molten.getConfig('api', {})
    };
    const api = molten.get('api');
    checkVersion({
      api,
      apiOpts
    });
  }
};
async function checkVersion({
  api,
  apiOpts
}) {
  const pollingEnabled = Config.get('ReleaseMonitor', 'pollingEnabled', true);
  if (!pollingEnabled) {
    return;
  }
  try {
    const releaseParent = Molten.releaseParent;
    const uiVersion = Molten.uiVersion;
    if (!releaseParent || !uiVersion) {
      return;
    }
    let lastRefresh = localStorage.getItem('lastRefresh');
    if (lastRefresh) {
      lastRefresh = new Date(lastRefresh);
      if (Date.now() - lastRefresh.valueOf() < FIVE_MINUTES) {
        return;
      }
      localStorage.removeItem('lastRefresh');
    }
    const executor = () => {
      return api.project(apiOpts.project).ui().pendingRelease().get({
        releaseParent,
        uiVersion
      });
    };
    const {
      pendingRelease,
      urgent
    } = await promiseRetry(executor);
    if (pendingRelease) {
      if (urgent) {
        await MoltenUtil.handleHardReload();
      } else {
        GlobalState.dispatch(UI.set('pendingRelease', true));
        return;
      }
    }
  } catch (err) {
    console.error(err);
    return;
  }
  setTimeout(() => checkVersion({
    api,
    apiOpts
  }), FIVE_MINUTES);
}